module.exports = __webpack_public_path__ + "img/dukaan91.d49fd158.png";